module.exports = __webpack_public_path__ + "img/icons.e24bf29e.png";